import * as React from 'react';
import { CianMortgageText } from '../../../../components/MortgageOffersTable';
import { getCianMortgageBannerUrl } from '../../../../utils/config';
import { useApplicationContext } from '../../../../utils/withApplicationContext';

export const CianMortgageTextContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const cianMortgageUrl = getCianMortgageBannerUrl(config);

  return <CianMortgageText cianMortgageUrl={cianMortgageUrl} />;
};
